@if (vm$ | async; as vm) {
  <div fxLayout="column">
    @if (vm?.agreements?.length) {
      <mat-card appearance="outlined" class="mat-space-bottom">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <h2 fxLayout="row" fxLayoutAlign="space-around center" class="date-heading">
            <button mat-icon-button (click)="previousMonth()" class="date-btn">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            {{ startMonthDate | date : 'dd.MM.yyyy' }} -
            {{ endMonthDate | date : 'dd.MM.yyyy' }}
            <button mat-icon-button (click)="nextMonth()" class="date-btn">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </h2>
        </div>
        <mat-card-content>
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" class="second-row" [formGroup]="activeAgreementFormGroup">
            <mat-form-field appearance="outline" fxFlex="50" class="second-row__input">
              <mat-label>{{ 'TSG-Agreement' | translate }}</mat-label>
              <mat-select formControlName="activeAgreement">
                @for (agreement of vm.agreements | filter : filterAgreements; track agreement) {
                  <mat-option #matOption [value]="agreement">{{
                    agreement.EmployerName
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (!(isApprovedByWorker$ | async) && canManageTimesheet()) {
              <button
                [visibleWithPermissions]="['ManageAsAExternalWorker']"
                mat-raised-button
                color="primary"
                fxFlex="10"
                (click)="approveTimesheet()"
                class="accept-btn second-row__btn"
                >
                {{ 'ApproveTimesheet' | translate }}
              </button>
            }
            @if (activeAgreement != null) {
              <div fxFlex="40" class="second-row__text">
                <h4 class="date-text">
                  {{ 'TSG-AgreementDateRange' | translate }}: <br />{{ activeAgreement.EmploymentDateFrom | date : 'yyyy-MM-dd' }} -
                  {{ activeAgreement.EmploymentDateTo | date : 'yyyy-MM-dd' }}
                </h4>
                @if (!!activeAgreement.TerminationEndDate) {
                  <h4 class="termination date-text">
                    {{ 'TSG-TerminationEndDate' | translate }}: {{ activeAgreement.TerminationEndDate | date : 'yyyy-MM-dd' }}
                  </h4>
                }
              </div>
            }
          </div>
          <div class="table-wrapper table-wrapper--desktop">
            <table mat-table [dataSource]="vm.timesheetRecords" class="mat-elevation-z1">
              <!-- Date Column -->
              <ng-container matColumnDef="date" class="date-column">
                <th mat-header-cell *matHeaderCellDef>{{ 'TSG-Date' | translate }}</th>
                <td
                  mat-cell
                  *matCellDef="let record"
              [ngClass]="{
                'current-day': isCurrentDate(record.Date),
                saturday: isSaturday(record.Date),
                sunday: isSunday(record.Date),
                holiday: isHoliday(record.Date)
              }"
                  >
                  {{ record.Date | date : 'yyyy-MM-dd' }}, {{ record.Date | dayOfWeek | translate }}
                </td>
              </ng-container>
              <!-- Absence Column -->
              <ng-container matColumnDef="absence">
                <th mat-header-cell *matHeaderCellDef>{{ 'TSG-Absence' | translate }}</th>
                <td mat-cell *matCellDef="let record">{{ record.Absence?.AbsenceSubtype }}</td>
              </ng-container>
              <!-- Start Column -->
              <ng-container matColumnDef="start">
                <th mat-header-cell *matHeaderCellDef>{{ 'TSG-StartDate' | translate }}</th>
                <td mat-cell *matCellDef="let record">{{ record.StartDate | date : 'HH:mm' }}</td>
              </ng-container>
              <!-- End Column -->
              <ng-container matColumnDef="end">
                <th mat-header-cell *matHeaderCellDef>{{ 'TSG-EndDate' | translate }}</th>
                <td mat-cell *matCellDef="let record">{{ record.EndDate | date : 'HH:mm' }}</td>
              </ng-container>
              <!-- Timespan Column -->
              <ng-container matColumnDef="timespan">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'TSG-Timespan' | translate }} | {{ 'TSG-Total' | translate }} : {{ totalTimespan$ | async | timespanToString }}
                </th>
                <td mat-cell *matCellDef="let record">{{ record.Timespan | timespanToString }}</td>
              </ng-container>
              <!-- Timespan Day Column -->
              @if (timespanEligibleEmploymentTypes.has(activeAgreement?.EmploymentTypeId)) {
                <ng-container matColumnDef="timespanDay">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'TimespanDay' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let record">{{ record.TimespanDay | timespanToString }}</td>
                </ng-container>
              }
              <!-- Timespan Night Column -->
              @if (timespanEligibleEmploymentTypes.has(activeAgreement?.EmploymentTypeId)) {
                <ng-container matColumnDef="timespanNight">
                  <th mat-header-cell *matHeaderCellDef>{{ 'TimespanNight' | translate }}</th>
                  <td mat-cell *matCellDef="let record">{{ record.TimespanNight | timespanToString }}</td>
                </ng-container>
              }
              <!-- WorkMode Column -->
              <ng-container matColumnDef="workMode">
                <th mat-header-cell *matHeaderCellDef>{{ 'WorkMode' | translate }}</th>
                <td class="work-mode-cell" mat-cell *matCellDef="let record">
                  <ul class="work-mode-list">
                    @for (item of record.WorkModes; track item) {
                      <li class="work-mode-label">
                        <span>{{ item.ShortNameLang }}</span>
                      </li>
                    }
                  </ul>
                </td>
              </ng-container>
              <!-- Actions Column -->
              @if (!isReadonly()) {
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let record">
                    @if (isCreateButtonVisible(record.Date)) {
                      <span
                        ><button
                        mat-icon-button
                        [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                        (click)="addRecord()"
                  [matTooltip]="
                    (isApproved$ | async)
                      ? ('TimesheetIsAlreadyApproved' | translate)
                      : (isCorrected$ | async)
                      ? ('TimesheetIsCorrected' | translate)
                      : null
                  "
                        >
                        <mat-icon>add</mat-icon>
                      </button></span
                      >
                    }
                    @if (record.Id !== 0 && isEditButtonVisible(record.Date)) {
                      <span
                        ><button
                        mat-icon-button
                        [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                        (click)="editRecord()"
                  [matTooltip]="
                    (isApproved$ | async)
                      ? ('TimesheetIsAlreadyApproved' | translate)
                      : (isCorrected$ | async)
                      ? ('TimesheetIsCorrected' | translate)
                      : null
                  "
                        >
                        <mat-icon>create</mat-icon>
                      </button></span
                      >
                    }
                    @if (record.Id !== 0 && isCopyButtonVisible(record)) {
                      <span
                        ><button
                        mat-icon-button
                        [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                        (click)="copyRecord()"
                  [matTooltip]="
                    (isApproved$ | async)
                      ? ('TimesheetIsAlreadyApproved' | translate)
                      : (isCorrected$ | async)
                      ? ('TimesheetIsCorrected' | translate)
                      : null
                  "
                        >
                        <mat-icon>content_copy</mat-icon>
                      </button></span
                      >
                    }
                    @if (record.Id !== 0 && isDeleteButtonVisible(record.Date)) {
                      <span
                        ><button
                        mat-icon-button
                        [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                        (click)="deleteRecord(record.Id)"
                  [matTooltip]="
                    (isApproved$ | async)
                      ? ('TimesheetIsAlreadyApproved' | translate)
                      : (isCorrected$ | async)
                      ? ('TimesheetIsCorrected' | translate)
                      : null
                  "
                        >
                        <mat-icon>delete</mat-icon>
                      </button></span
                      >
                    }
                  </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                (mouseenter)="onMouseEnterSelectedRow(row)"
                (mouseleave)="onMouseLeaveSelectedRow(row)"
                [ngClass]="{ selected: row === selectedRow }"
              ></tr>
            </table>
          </div>
          <div class="table-wrapper table-wrapper--mobile">
            <table class="responsive-table">
              @for (record of vm.timesheetRecords; track record) {
                <tbody>
                  <!-- Date Column -->
                  <tr>
                    <td>{{ 'TSG-Date' | translate }}</td>
                    <td
                [ngClass]="{
                  'current-day': isCurrentDate(record.Date),
                  saturday: isSaturday(record.Date),
                  sunday: isSunday(record.Date)
                }"
                      >
                      {{ record.Date | date : 'yyyy-MM-dd' }}, {{ record.Date | dayOfWeek | translate }}
                    </td>
                  </tr>
                  <!-- Date Column -->
                  <tr>
                    <td>{{ 'TSG-WorkTime' | translate }}</td>
                    <td>{{ record.StartDate | date : 'HH:mm' }} - {{ record.EndDate | date : 'HH:mm' }}</td>
                  </tr>
                  <!-- Timespan -->
                  @if (activeAgreement?.EmploymentTypeId === EmploymentType.MandateAgreement || activeAgreement?.EmploymentTypeId === EmploymentType.TemporaryMandateAgreement) {
                    <tr>
                      <td>
                        {{ 'TimespanDay' | translate }}
                      </td>
                      <td>{{ record.TimespanDay | timespanToString }}</td>
                      <td>{{ 'TimespanNight' | translate }}</td>
                      <td>{{ record.TimespanNight | timespanToString }}</td>
                    </tr>
                  }
                  <!-- WorkModes -->
                  @if (record.WorkModes && record.WorkModes.length) {
                    <tr>
                      <td>
                        <ul class="work-mode-list">
                          @for (item of record.WorkModes; track item) {
                            <li class="work-mode-label">
                              <span>{{ item.ShortNameLang }}</span>
                            </li>
                          }
                        </ul>
                      </td>
                    </tr>
                  }
                  <!-- Actions  -->
                  @if (!isReadonly()) {
                    <tr (mouseenter)="onMouseEnterSelectedRow(record)" (mouseleave)="onMouseLeaveSelectedRow(record)">
                      <td class="actions-btn">
                        @if (isCreateButtonVisible(record.Date)) {
                          <span
                            ><button
                            mat-icon-button
                            [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                            (click)="addRecord()"
                    [matTooltip]="
                      (isApproved$ | async)
                        ? ('TimesheetIsAlreadyApproved' | translate)
                        : (isCorrected$ | async)
                        ? ('TimesheetIsCorrected' | translate)
                        : null
                    "
                            >
                            <mat-icon>add</mat-icon>
                          </button></span
                          >
                        }
                        @if (record.Id !== 0 && isEditButtonVisible(record.Date)) {
                          <span
                            ><button
                            mat-icon-button
                            [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                            (click)="editRecord()"
                    [matTooltip]="
                      (isApproved$ | async)
                        ? ('TimesheetIsAlreadyApproved' | translate)
                        : (isCorrected$ | async)
                        ? ('TimesheetIsCorrected' | translate)
                        : null
                    "
                            >
                            <mat-icon>create</mat-icon>
                          </button></span
                          >
                        }
                        @if (record.Id !== 0 && isCopyButtonVisible(record)) {
                          <span
                            ><button
                            mat-icon-button
                            [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                            (click)="copyRecord()"
                    [matTooltip]="
                      (isApproved$ | async)
                        ? ('TimesheetIsAlreadyApproved' | translate)
                        : (isCorrected$ | async)
                        ? ('TimesheetIsCorrected' | translate)
                        : null
                    "
                            >
                            <mat-icon>content_copy</mat-icon>
                          </button></span
                          >
                        }
                        @if (record.Id !== 0 && isDeleteButtonVisible(record.Date)) {
                          <span
                            ><button
                            mat-icon-button
                            [disabled]="(isApproved$ | async) || (isCorrected$ | async)"
                            (click)="deleteRecord(record.Id)"
                    [matTooltip]="
                      (isApproved$ | async)
                        ? ('TimesheetIsAlreadyApproved' | translate)
                        : (isCorrected$ | async)
                        ? ('TimesheetIsCorrected' | translate)
                        : null
                    "
                            >
                            <mat-icon>delete</mat-icon>
                          </button></span
                          >
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              }
            </table>
          </div>
          <tr>
            <div class="summary">
              <div class="title">{{ 'WF-Summary' | translate }}:</div>
              <div>
                {{ 'TSG-Total' | translate }}: {{ totalTimespan$ | async | timespanToString }}
                @if (activeAgreement?.EmploymentTypeId === EmploymentType.MandateAgreement) {
                  ({{ 'TSG-TotalDay' | translate }}: {{ totalTimespanDay$ | async | timespanToString }}, {{ 'TSG-TotalNight' | translate }}:
                  {{ totalTimespanNight$ | async | timespanToString }})
                }
              </div>
              @if (isConcludedHomeOfficeRemoteAvailable) {
                <div>
                  {{ 'ConcludedHomeOfficeRemoteMonthAmount' | translate : { daysAmount: concludedHomeOfficeRemoteMonthAmount } }}
                </div>
              }
              @if (isHomeOfficeOnDemandAvailable) {
                <div>
                  {{
                  'HomeOfficeOnDemandMonthAmount'
                  | translate : { daysAmount: homeOfficeOnDemandMonthAmount, yearDaysAmount: homeOfficeOnDemandYearAmount }
                  }}
                </div>
              }
            </div>
          </tr>
        </mat-card-content>
      </mat-card>
    }
  </div>
}

@if (isActiveAgreementsListEmpty()) {
  <app-agreement-not-available></app-agreement-not-available>
}
